import React from "react";
import { GetStaticProps } from "next";
import { MetaDataPage, MetaDataPageType } from "src/models/meta/getMetaData";
import { requestPharmacyPage } from "src/utils/helpers/requestApi/serverFetchPage/requestPharmacyPage";
import MetaContainer from "src/components/common/Layout/components/MetaContainer/MetaContainer";
import { getPharmaciesSchema } from "src/models/pharmacies/getPharmacies";
import PharmacyPage from "src/components/PharmacyPage/PharmacyPage";

interface PharmacyProps {
  pharmacyData: getPharmaciesSchema;
}

const Pharmacy: React.FC<PharmacyProps & MetaDataPage> = ({
  pharmacyData,
  metaData,
}) => {
  return (
    <MetaContainer {...metaData}>
      <PharmacyPage pageTitle={metaData.h1} pharmacyData={pharmacyData} />
    </MetaContainer>
  );
};

export const getStaticPaths = async () => {
  return {
    paths: [
      {
        params: {
          city: "moskva",
          company: "magnit",
          pharmacy: "33028",
        },
      },
    ],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = requestPharmacyPage.bind(
  null,
  MetaDataPageType.aptekiPharmacy
);

export default Pharmacy;
